/* eslint-disable no-param-reassign */
import React from 'react';
import * as style from './iframe.css';

/*
  name : for iframe
  note : for browsers that doesn't support iframe
  src : address of the document to embed in the iframe
  srcdoc : HTML content of the page to show in the iframe
  wrapperClassName : to edit the wrapper styles
*/

const Iframe = ({
  className,
  style: _style,
  iframeRef,
  name = 'striveframe',
  note,
  src,
  srcdoc,
  title,
  wrapperClassName,
  ariaId = null
}) => {
  return (
    <div className={wrapperClassName || style.wrapper} style={_style} id={ariaId}>
      <iframe
        className={className}
        name={name}
        ref={iframeRef}
        src={src}
        srcDoc={srcdoc}
        title={title}
      >
        {Boolean(note) && <p>{note}</p>}
      </iframe>
    </div>
  );
};

export default Iframe;
